<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
        {
          "num_cand": "U2FsdGVkX19ag51VaCpjhXUBk5GoxXFo+wDumOrzWbA=",
          "cpf": "U2FsdGVkX19wS9sHvhoEoTC9fq5VgXxL6/XGBJkTSRk="
        }, {
          "num_cand": "U2FsdGVkX196LvOrqgwx4SSlgOGGRREtKX5wN666WTg=",
          "cpf": "U2FsdGVkX1+WHkegFSULD82cmwtZETbmB7gOZTJv6jg="
        }, {
          "num_cand": "U2FsdGVkX18DGqB05W0DGY/BCV4mQNYQ0fcLQ2SG+hU=",
          "cpf": "U2FsdGVkX1+bCqJfRbU/SRTWbWRlmKNqLCKP+skoxqA="
        }, {
          "num_cand": "U2FsdGVkX1+JbceERSB/IHpzRLaL1ewkKH04nMbeL0s=",
          "cpf": "U2FsdGVkX19rMv+eU4s3LQvi4iqBUTWD0sxk1QxL6QE="
        }, {
          "num_cand": "U2FsdGVkX1/0sl1gHbEBTwh5OvuJDJ371mTNVltIv6Q=",
          "cpf": "U2FsdGVkX19Ki9kht2Wy9ISwXBF2T1c1XuWbLgUdu14="
        }, {
          "num_cand": "U2FsdGVkX18k8/b/t4fwXSUnS4zt3b0bsmmzw1UOr74=",
          "cpf": "U2FsdGVkX19kN/tIZDvwuZ5jjKawoLXAXumCpQFCxUY="
        }, {
          "num_cand": "U2FsdGVkX1/LOQVdXmIk2BTbEKnHXbmJ2T5Nuj6lqMs=",
          "cpf": "U2FsdGVkX19A0n3xsmUhGFlydTZ1ESlRi/tU1W1KjN8="
        }, {
          "num_cand": "U2FsdGVkX19VgAPBR3wdoAp82tLJINc6n3TvOhjkDio=",
          "cpf": "U2FsdGVkX1/pRLxAN4LXvQoPkyV754IscLTHIe91nwQ="
        }, {
          "num_cand": "U2FsdGVkX196A0J7akOW+chfnFIW/KJeg3utxINUToI=",
          "cpf": "U2FsdGVkX19hE9SLsRRT5CN0qZ60Ny+vC8iH7dj8pD0="
        }, {
          "num_cand": "U2FsdGVkX19d9ioo8NiHCjRKd/0BN6BC0dTK7zDpfgM=",
          "cpf": "U2FsdGVkX1+931bGITCPnNHXFDDKrFLZTGM7z3QgKBY="
        }, {
          "num_cand": "U2FsdGVkX18yzXp5c2r04gldK4K+ekkYgyniVpKp6LA=",
          "cpf": "U2FsdGVkX19epC0cuz/b18D9sya6TTsWmMrPFylRU1w="
        }, {
          "num_cand": "U2FsdGVkX1+K+f3rQSPwjlhj+Kp4uZ4roazLBdwfhas=",
          "cpf": "U2FsdGVkX1+EG6PNY1PqGPR0yxKXQAFL//9QHAj+DJw="
        }, {
          "num_cand": "U2FsdGVkX1/eV0ViQOduD3IKSqjs9pJjrJDei2HvaQc=",
          "cpf": "U2FsdGVkX18VOsTO8aAVu0BC3nKNu5muJ5nDvsRMY00="
        }, {
          "num_cand": "U2FsdGVkX1+efqzhae4ruCd3l/PB+5wNLK/6iXtUHg4=",
          "cpf": "U2FsdGVkX18cq1PLnkBdnApq2KUiHypWmdGg1Kaku+w="
        }, {
          "num_cand": "U2FsdGVkX1/M+J110E4rNWCHBOk1nRG/hGio+hnEo/k=",
          "cpf": "U2FsdGVkX1+JC4iKfpjIwvXOU1AJNSOnvUgFcCwbtwQ="
        }, {
          "num_cand": "U2FsdGVkX19y00yzrHVrR9i59D8Q6Is6/xQMxD04xqo=",
          "cpf": "U2FsdGVkX1+XxL3xyEUQ3d5FZDUAQUja17KFwjI8YHY="
        }, {
          "num_cand": "U2FsdGVkX18ujowdw8Y0w0jgEJGP9ihorKngvk7I4d4=",
          "cpf": "U2FsdGVkX1/p7ykBP8S1NmpFzczdGc44+9jg4XT5sBc="
        }, {
          "num_cand": "U2FsdGVkX1+zrP7WI2b6GXKvMoTzs/X2cg4yoE8h/gM=",
          "cpf": "U2FsdGVkX1/vHKer0y44rE4BIM963EMH79JYL0gabZc="
        }, {
          "num_cand": "U2FsdGVkX18a+P+S6146pN+IegM5CteLk7vjWdFsoig=",
          "cpf": "U2FsdGVkX18ewDoOric73lzIn2Zw/KPNga1nwA8kcIc="
        }, {
          "num_cand": "U2FsdGVkX18s4E+wr9vx/Yvc3hAxMge0me2rTZZR+zg=",
          "cpf": "U2FsdGVkX1/RxFfwUkcMJyORkfUJ2Awj4zWuAzq1PGM="
        }, {
          "num_cand": "U2FsdGVkX1+9+16syq4p0h1kKhdSllxuBgm68HeFRZg=",
          "cpf": "U2FsdGVkX1+PJNybVsQX8uOYMflii1nTAnkAu9PajZc="
        }, {
          "num_cand": "U2FsdGVkX1+hm8UqQEnFW7rMUFTknN8zkQdOXMkyErc=",
          "cpf": "U2FsdGVkX1/5ACOS7hr/FFs5wyflGHmBuRK51h0bB20="
        }, {
          "num_cand": "U2FsdGVkX181izmDX1WBb3ZrE+WZ1J3O8u3hMqxTW/E=",
          "cpf": "U2FsdGVkX18SOrd6dWrzgzbAh28nrGa7qKloQo2gZeU="
        }, {
          "num_cand": "U2FsdGVkX1+g0PHjwqbnzaEA3azqQteTR35J3LvR0aY=",
          "cpf": "U2FsdGVkX1+AC3HloNfFifW+Z75bUSkyP0gxCjhym9o="
        }, {
          "num_cand": "U2FsdGVkX18Cx4Z2/CJWZUf42A2u55rWC1jqKRYXgR8=",
          "cpf": "U2FsdGVkX19d6cYaw1vbOJHu3b4doSNNaaozA4sATNM="
        }, {
          "num_cand": "U2FsdGVkX1+PKXrMKJpfIDVfi5kOkdwTnEk3K/AL5+g=",
          "cpf": "U2FsdGVkX1/nH5Ek4jm12+FsICR0Tvh2t68F9q0stSA="
        }, {
          "num_cand": "U2FsdGVkX18FZowC+AgAqIk+5h0mXFMZr35LZApocRw=",
          "cpf": "U2FsdGVkX1+sunxaRU74TXlupBCRsdKryI3DTTbKuvc="
        }, {
          "num_cand": "U2FsdGVkX18oqsAXj5k9PjdUPr3I0n3Cu/ZDkcxaF/w=",
          "cpf": "U2FsdGVkX19W6Ty/nmaOp6XiR3b+/CJm5B4GATT0fNU="
        }, {
          "num_cand": "U2FsdGVkX1/IKMgj229pvTc0lgUcdgv4PN/r7UEFqhk=",
          "cpf": "U2FsdGVkX19j9uPUEW0qMfEdILyz5AeJrpGE7ljxWzM="
        }, {
          "num_cand": "U2FsdGVkX19lKdEa1wh8Lz+77Hg5u0J/ERYqgyUQq2c=",
          "cpf": "U2FsdGVkX18cF2485kiX0h49XpnCl4wX9z9XzZFFv+c="
        }, {
          "num_cand": "U2FsdGVkX1/XMbEg8e9ts13e1oCslqIO7kAR3ryvvNM=",
          "cpf": "U2FsdGVkX19kgPBSaQdk9w7ilY5/gQS8R1CR7nQi/Pk="
        }, {
          "num_cand": "U2FsdGVkX1/sHL1ta4NwABSRWF03TIrru2fDep6ILPw=",
          "cpf": "U2FsdGVkX1/FQG4jycd5eNc61koLEcbEacX/wb5xIy4="
        }, {
          "num_cand": "U2FsdGVkX1/VIlgRud/GsbDnZHzM88Rr2C6vnx3+nfw=",
          "cpf": "U2FsdGVkX19EL2bJ9eKcmwqZ+5f6XsnMwVx2HbMRqdM="
        }, {
          "num_cand": "U2FsdGVkX1/5eF4RjlojXiMHFJKMAxp4N7e9EH1z6rY=",
          "cpf": "U2FsdGVkX18KBFZe4Ysoh7cnJjmfaDWQyeP3TK4cNvo="
        }, {
          "num_cand": "U2FsdGVkX1+1iMpNiUjNsOuJBK1FUBjvXrlDBY5Wqpg=",
          "cpf": "U2FsdGVkX1/bY88Q8iN0N7u8svOfc/clpLnf6s93XiY="
        }, {
          "num_cand": "U2FsdGVkX193N4fI7L3nEo270UczWmi9J5USeitZbuw=",
          "cpf": "U2FsdGVkX1/N/vVCT5SCRxOmnOJKhfe3h+j0Dtn6M+E="
        }, {
          "num_cand": "U2FsdGVkX1/IGGoNqpTcQwdiTSt+QsVEKBVoFNPi9vg=",
          "cpf": "U2FsdGVkX188MlBbXmZ3adhLDQl1N72fw5xn6qzDHUM="
        }, {
          "num_cand": "U2FsdGVkX18U+Ax9yekHV6DxkQA8GJAaqI699EiMYiw=",
          "cpf": "U2FsdGVkX191zPNoh7P8zgkNFmAlzEH0ZhIZvhDdF8s="
        }, {
          "num_cand": "U2FsdGVkX19p6pcuHguJPgGXUj6lqbM8eWY3d2KRp80=",
          "cpf": "U2FsdGVkX18EuJOyHqAs40mRkmSUw6eUvhv5w5esuSI="
        }, {
          "num_cand": "U2FsdGVkX18pff6DJPW7oD1gXicC0NWG3igRegQyY0c=",
          "cpf": "U2FsdGVkX1/TJwII0OCu+XN0idn/4L9TDKkXEByL3oE="
        }, {
          "num_cand": "U2FsdGVkX186RXnrbl5wCv7jOQ5ChZRctu0IRZe8UPg=",
          "cpf": "U2FsdGVkX1/4W0STSwZOUEV0dkDgpCVwZxjkrMZOCSY="
        }, {
          "num_cand": "U2FsdGVkX1+bRfwu/DoctVHMpiEJ94enuQdTlBi91vo=",
          "cpf": "U2FsdGVkX1/4aR2uXpfx7BqxcIxrJkuFH48eYQIoAKc="
        }, {
          "num_cand": "U2FsdGVkX1/N5enwMyA4aKfqyLhxD8sikHkDEPNnldc=",
          "cpf": "U2FsdGVkX18VwBCQqgulS3MyLL9Se06tAXLn5WYOa1Q="
        }, {
          "num_cand": "U2FsdGVkX18jykacOzOH27YCEYraka2gJzUJWq+EVOk=",
          "cpf": "U2FsdGVkX1/HO1o76zR0EqqT1hs7cLSgXqeSE/cP0zc="
        }, {
          "num_cand": "U2FsdGVkX18/wazUaWFZaqAW41+PAyQMUJ9I7lhvIvI=",
          "cpf": "U2FsdGVkX1+hH9sApPHubJNDBCwLbwW7KYmG15p/H50="
        }, {
          "num_cand": "U2FsdGVkX18hLPESDrBQN1nnks1PoQ2pHb4k8EX+uxQ=",
          "cpf": "U2FsdGVkX194/obUw4UyvulMgEUmmGY0A+xrfW0RiVA="
        }, {
          "num_cand": "U2FsdGVkX1/zyVEmG6PZv8JG++NRVoj5IkcL9GR+UAU=",
          "cpf": "U2FsdGVkX1/KI5jC8lGZi1D+CQ5O2ZhotsX+Qb4T448="
        }, {
          "num_cand": "U2FsdGVkX19oGr4G6EXKlpArg4vG2B3Y9CBLFezH9LM=",
          "cpf": "U2FsdGVkX1873557ldWg7x0prfgN5QhJWZ7v4J3s0DA="
        }, {
          "num_cand": "U2FsdGVkX1/Qve59uqnnOwpqU3607qCWuXseax9M2S0=",
          "cpf": "U2FsdGVkX1/xMAzAZ8bEkFhFEF8Q5zK5oEq7bs5UD/o="
        }, {
          "num_cand": "U2FsdGVkX18W4Js8zW5CbJ+Z9x3FfrOSkPbZ3vc/J0E=",
          "cpf": "U2FsdGVkX190HSGYUpOWsrLNxfcUv+ddy13iKDgBHko="
        }, {
          "num_cand": "U2FsdGVkX19mrV8u2IxfOkx15L5isa17trC1URcpP9Y=",
          "cpf": "U2FsdGVkX19Ok2gGjnDtlRidMorZihrcKD5bVv8VazY="
        }, {
          "num_cand": "U2FsdGVkX18q1sYEO+wXielUQd7+dV6p3f5AK2J1e0k=",
          "cpf": "U2FsdGVkX1+LAbAw3ovAbsu/AIH0DUm9WOmubI3nYrg="
        }, {
          "num_cand": "U2FsdGVkX1+amzQvYHA75ssVMaflE7/cdMhpZuGgrfs=",
          "cpf": "U2FsdGVkX18lhfgW3o5VHMHmuI6zKw4JB3YZUVu/V4A="
        }, {
          "num_cand": "U2FsdGVkX18ZMh0H79zkLglbUtTjaJEAywCEf8PHgTk=",
          "cpf": "U2FsdGVkX19bsZerEov2PDZxe1vJU3/RDfX0Ph+qQ9k="
        }, {
          "num_cand": "U2FsdGVkX1+xhqP1goibUkz0pclS74LYh3ev526T550=",
          "cpf": "U2FsdGVkX1924ysq+rfH6bCCivowKr/dMvMHyv0ugkw="
        }, {
          "num_cand": "U2FsdGVkX19V4MjiKsP1WKuO/srjaP8UrfJyP9BXN84=",
          "cpf": "U2FsdGVkX18IrsZjtlRMtiHgesDVKOT81a9UCEOaqoA="
        }, {
          "num_cand": "U2FsdGVkX180rdoWITRvtTkP2ZeUGUrj9DzqcfbRfAQ=",
          "cpf": "U2FsdGVkX1+DXS5mQ8x8Q62W5Y1GeRNO4uCxCcN62A4="
        }, {
          "num_cand": "U2FsdGVkX198WBTPmEW70p9szIMxnZE0xh4s7tRBd4c=",
          "cpf": "U2FsdGVkX1+gYy3GJZcdG+x0rXH8Fv2Fu79tgkzT7QQ="
        }, {
          "num_cand": "U2FsdGVkX19hyYIp6hEsQXqJpCRJbkyqZicc+TzBmBc=",
          "cpf": "U2FsdGVkX18VE2nuwhfQXvnbebcJq3x/8wA00jZAqiw="
        }, {
          "num_cand": "U2FsdGVkX1+UssgrGczyNwsskmsHbIevVXHqcFH+tJg=",
          "cpf": "U2FsdGVkX18qR3dYzL54vg7Rv3hMl4H7vgDivUeqwGo="
        }, {
          "num_cand": "U2FsdGVkX18nH4sgwEil6KdElln8uqKFVcfSGmeUeTQ=",
          "cpf": "U2FsdGVkX19ftMJvFFnR9PbuqL9KdF0JPZX5PDlC/tg="
        }, {
          "num_cand": "U2FsdGVkX18W7mAN8VOHIG7SxuYr17BrObGuryOoLMc=",
          "cpf": "U2FsdGVkX1+Y5RCImHI3HUJp/+AElg0zLG12QN7Sntg="
        }, {
          "num_cand": "U2FsdGVkX1/1e012pHbjlkHwhj0bXg2NpP46vQ7tj3M=",
          "cpf": "U2FsdGVkX180lIU8omEEe52x3IkkWUvXVbZ5f7reopc="
        }, {
          "num_cand": "U2FsdGVkX19H9NwqL4jfprhm9/WgeZMd1GTqBH3q5zo=",
          "cpf": "U2FsdGVkX18syYcdDXR7mvHsQI/TD1n0adXi72sLXBc="
        }, {
          "num_cand": "U2FsdGVkX1900j52cCYKWbhHcpmkaMdrugR12xsej9Q=",
          "cpf": "U2FsdGVkX1/djICXFHDwlKloLjTtiZn/SBywfVICqbA="
        }, {
          "num_cand": "U2FsdGVkX1+e0G/8y3w7cAOZBN2/GYM3ohPzTtWo1AQ=",
          "cpf": "U2FsdGVkX18a/OxMWdx8aR+C6219Pa7SFkdjTbwzLYA="
        }, {
          "num_cand": "U2FsdGVkX1+9u8GpVzvaJ5gVL9uhBcpdEdVC2S/tdLk=",
          "cpf": "U2FsdGVkX1/lMHvAfV8G3UkarHZhC+kSajq2rMVcL6o="
        }, {
          "num_cand": "U2FsdGVkX188BNDN5VVGroLHVcbOmpBu6bYnl4HH2UI=",
          "cpf": "U2FsdGVkX1/fLJuJWK42dvDIuvIhOaZn3S1cUjJfBb0="
        }, {
          "num_cand": "U2FsdGVkX18p8vt3kWxHzsnUWr/eyeWnKt3prbRR6pM=",
          "cpf": "U2FsdGVkX1+Nf3kdNrItQ7oLpJqcQ6IJhxJbgI2eEOs="
        }, {
          "num_cand": "U2FsdGVkX1+8s5zQmgStvg48hNOvCrEzgT5DRZlSZTY=",
          "cpf": "U2FsdGVkX1+BhOBPbs62yZ7Y/4zO2Sp63+CspRfO0A4="
        }, {
          "num_cand": "U2FsdGVkX1/bLdpOtKVgNALXke9TSWB6vwz3G5Nnego=",
          "cpf": "U2FsdGVkX19caExCSxoVTnAvUJkVNWdwbRh4aPi4IVQ="
        }, {
          "num_cand": "U2FsdGVkX1+WQQQZhLd52ELM6Xt9znYOUKRVoHyoQ6M=",
          "cpf": "U2FsdGVkX18K8e+klILphjyBTRPulKBHNH25DEN1mdQ="
        }, {
          "num_cand": "U2FsdGVkX19RVoDook5fMHy0zOCQAqJfbwnHwDKGW1Y=",
          "cpf": "U2FsdGVkX18ePEQ4mIVBumw1mn0RInhsV7lc7L7Sgig="
        }, {
          "num_cand": "U2FsdGVkX1+Z6hd5t0w2BiXI3983+YZBRRRrwcM8Ufg=",
          "cpf": "U2FsdGVkX1+W1rNvusDP9GF0yPCsQ/mSwNuTa17Yk9g="
        }, {
          "num_cand": "U2FsdGVkX19ZVW3tUIFIwsGhkrE/FDqeIxz4DE0vQww=",
          "cpf": "U2FsdGVkX1+kA/LiDi60Boi1VqYb6/KoZ58jS34NA4M="
        }, {
          "num_cand": "U2FsdGVkX1+l8pU6FCGneAO56KgHLs7WfGeOz1Au95I=",
          "cpf": "U2FsdGVkX19pE/7Q595zgisy0fNusN4MJHdniDmK6zo="
        }, {
          "num_cand": "U2FsdGVkX18eItoh1SJle92uD7vwk7hdmBlyV4sch4w=",
          "cpf": "U2FsdGVkX19ojV2yxduSeHj2nigdhOn/WedaSvWclfo="
        }, {
          "num_cand": "U2FsdGVkX1+fcL0jC3XZSZae0Y024txFLgsN9CsGpAI=",
          "cpf": "U2FsdGVkX1+CwyzxzZchI85xuqr9IaNmOg59lm4y+ms="
        }, {
          "num_cand": "U2FsdGVkX19nV4WHyZmGHtyPgHD2XyBGnqJRAhe8H7s=",
          "cpf": "U2FsdGVkX1+3jU1eCoJkrxnLRDL2SzOmKNzgih+crjY="
        }, {
          "num_cand": "U2FsdGVkX1/D17xju/l71fMhLdmkbv5ZB5HLmk8ctiU=",
          "cpf": "U2FsdGVkX18Hps7kdD7ZFhdbZLBHoVokIy1wxc/57dk="
        }, {
          "num_cand": "U2FsdGVkX1/VMDrPzQwq8DXiBNe+ySa80JroT8ZCGs0=",
          "cpf": "U2FsdGVkX19ayb4ABPQYzICcCL1MaUqbT5f8wIrAHbg="
        }, {
          "num_cand": "U2FsdGVkX182bwjJxpJ2mPq0tfktC0CpIyLPWK5hXTM=",
          "cpf": "U2FsdGVkX1+EDIGkGjIzr2E0uE/h2EKJezzJJjOa4ns="
        }, {
          "num_cand": "U2FsdGVkX1+KpGKz5zRTzKpKKUhWQbIqITdHZ8iixDM=",
          "cpf": "U2FsdGVkX1+MXujLo/yiKY7DcdFQewrw9AiC3fBQucw="
        }, {
          "num_cand": "U2FsdGVkX1+xCGLsWN+AY8NU6yQrI7J1RLYi7NZKipE=",
          "cpf": "U2FsdGVkX18h5H/cUIasBDcbdW3VbJlq/eKK8o94Wws="
        }, {
          "num_cand": "U2FsdGVkX1+UKg+HpoIXK+uFDavEO9KsPNIOEGq9KVE=",
          "cpf": "U2FsdGVkX18w2h9EEw0nX0E4+0v4AnnoKw++nOKmgnQ="
        }, {
          "num_cand": "U2FsdGVkX1+M82acix6fI1q6kreS52OVCq71Z0Tz4Ec=",
          "cpf": "U2FsdGVkX18gkDUpMp/TdM7g9Tt170n4KyJ894HDWSI="
        }, {
          "num_cand": "U2FsdGVkX19vwdNmHaCpGualeOS7+nDsjZSKA4YbSqw=",
          "cpf": "U2FsdGVkX18GqTmvupmgOfS9DPhkZMfxe64CM2sLTWA="
        }, {
          "num_cand": "U2FsdGVkX184sPSvnY1Ip0ZZK1vFHChpA+ARCExSNDY=",
          "cpf": "U2FsdGVkX18gkpa66q+Iv+vArHYvcJdOp1uhWcfeTDA="
        }, {
          "num_cand": "U2FsdGVkX1//9wrvL5ITbMeDfHPogoN0C6yHH72jDwA=",
          "cpf": "U2FsdGVkX19DBfDoG1nLQpcj3tfQNWAJCEtSvhBMNbg="
        }, {
          "num_cand": "U2FsdGVkX1/F40KdmrgVD2z4iVwih/xXJ3utIpN0faU=",
          "cpf": "U2FsdGVkX19dsYguwk2pmr9HzfQ0NoTqAuNOxHI0fWs="
        }, {
          "num_cand": "U2FsdGVkX1+Sz3K6fi1GJteQ1DUKT/uCq9zoRE7gQqU=",
          "cpf": "U2FsdGVkX18IXpR4+/kmtJ/GgUnePM2WRdTP5UJ/smg="
        }, {
          "num_cand": "U2FsdGVkX18UEPBEg/z6mK/V93fi7nmTnxtuQtaW37s=",
          "cpf": "U2FsdGVkX194oev8RXQ1Fgcq17WfTjCqqHWWpGsN+6I="
        }, {
          "num_cand": "U2FsdGVkX18WPV6H1Dnz7UEi0u5l+w+PEBSmpWIUY5A=",
          "cpf": "U2FsdGVkX18WYQJgw5TP4iRG4Q22k6XUe8npQgqsoKw="
        }, {
          "num_cand": "U2FsdGVkX1/rmWY2RRtgRIY+sy/V2z7wWWHeOnCv1W8=",
          "cpf": "U2FsdGVkX1+H8gfVph5pqISWkDECw+J8oX9ApEj7KqQ="
        }, {
          "num_cand": "U2FsdGVkX1/jLmW1u9Spc9Fk9pSaabnDrNLlgMVE8EE=",
          "cpf": "U2FsdGVkX19RcM+IYdtjcVQpYY2EFR73o6oE7LlObAY="
        }, {
          "num_cand": "U2FsdGVkX19kNCT963EGWzLhGIf/u3+HgvOXdlIHXt0=",
          "cpf": "U2FsdGVkX18FwaJJil3CWygvcVoUbpPXzKwLGXTHHFo="
        }, {
          "num_cand": "U2FsdGVkX19iAl9QAHWai+czipOVmHmT0xVjFxEu4bE=",
          "cpf": "U2FsdGVkX19SGWjwkHA/VBB1KuJhZXp+Bvgwypuu7YM="
        }, {
          "num_cand": "U2FsdGVkX1/X6v1P22AjKYamyLAD+5nCbx84pw2MHiw=",
          "cpf": "U2FsdGVkX1//GHuaYtN78VJ8Ck+82n2+vO1ZNzfaADw="
        }, {
          "num_cand": "U2FsdGVkX19JHLVTsbywK1bheh1weP6EMp/3ndthxzM=",
          "cpf": "U2FsdGVkX1+LSNr29bZ+/jVJfE3QKRngfwt3quUDLsw="
        }, {
          "num_cand": "U2FsdGVkX1+OqLaKSQ3hu62bfLs3Bc3x24V31vxPJ7s=",
          "cpf": "U2FsdGVkX1/CcZHq5KQb8Bb3VnysKUuzmoA7hj+z4NM="
        }, {
          "num_cand": "U2FsdGVkX1+ejSbNmc1JzbU13RoQOk0VgNs+L6+uVZk=",
          "cpf": "U2FsdGVkX1/Q3WQe7zJ5efUV/tp4y7B0yplQbn/nWrk="
        }, {
          "num_cand": "U2FsdGVkX19qnVmuxlIKxkFsW8rlrnowUNelV0f6ekc=",
          "cpf": "U2FsdGVkX19CTu+LBpdUJhPXT9TQcS0laq3rXqVpf9I="
        }, {
          "num_cand": "U2FsdGVkX1/7YZzVbOZeiJKgn9Xlf1VVOcdJC1VHzac=",
          "cpf": "U2FsdGVkX1/IdeC3o9v+GxqjkBWuzdCZOn3HRLtvW6Y="
        }, {
          "num_cand": "U2FsdGVkX18yi77Uy38Y114m2fAsjo+67qGHIVe903s=",
          "cpf": "U2FsdGVkX19UtQla+ROb6JnBZgWXGoMCgGxGWx2OLs0="
        }, {
          "num_cand": "U2FsdGVkX1+kKaInOPLpArmGXy6Yp6vIyqPfueCII9Y=",
          "cpf": "U2FsdGVkX1+rrq538EMBrha3V7du8Wye2AQFLwaqOTU="
        }, {
          "num_cand": "U2FsdGVkX19fAF8jlkG+/lLGYMpS6VyOv453bZGo40w=",
          "cpf": "U2FsdGVkX18k0B7/luN7inTULQ7lTcSV19HlNs8ir5A="
        }, {
          "num_cand": "U2FsdGVkX19GKm0B7jAEgLxCbVh7tjfz/MuMfhJ3xOw=",
          "cpf": "U2FsdGVkX1/HsV44l4BjS40agQLgMfijXRA3Dmv6lNI="
        }, {
          "num_cand": "U2FsdGVkX18xKr8ZTLQaWekd5/YGBbUH1SjCKB4xOo8=",
          "cpf": "U2FsdGVkX18DKQyvz0ZVlNgymHTdRR7moWcH8HHyMOU="
        }, {
          "num_cand": "U2FsdGVkX19hWveC9Vtv4dGPqRRLuoMSeEOKH/KMmUc=",
          "cpf": "U2FsdGVkX19SPqgQm8Z1UXvlBD94zhiwiTC+CQ+GlJw="
        }, {
          "num_cand": "U2FsdGVkX1/mnrvrG9C4NcgafpvXCrAurCkknbYMDXY=",
          "cpf": "U2FsdGVkX1/XBoY/5snzPpK3sYpaabl043Z+Bm1ldko="
        }, {
          "num_cand": "U2FsdGVkX19z1MmZEdmudC/M+izb8rdxRoc7oR3fId4=",
          "cpf": "U2FsdGVkX1/Esf14r7UWAKe06neXOT06jWcDeG3t5+k="
        }, {
          "num_cand": "U2FsdGVkX199lDhnG37aEUHisu/4ls1P6fAdOgVNzI8=",
          "cpf": "U2FsdGVkX1+0pKijvh0Ko4PDNlkRxPUEXzimkjuCJXY="
        }, {
          "num_cand": "U2FsdGVkX19o0014txphdHD210YdPHXDsL8vRPy+VZA=",
          "cpf": "U2FsdGVkX1/X36TvNWNOSnwvzPz/U55y8oLZ0h1ICrk="
        }, {
          "num_cand": "U2FsdGVkX19WEc5kIrErY5ba4b382nkPt/DdV5/PL5c=",
          "cpf": "U2FsdGVkX1+OoBtUjG3i9OEA+PmMIeBdL50CEf5mtGk="
        }, {
          "num_cand": "U2FsdGVkX18PKHtag5g9SaD8EbN/k3s6M59doLgDvrI=",
          "cpf": "U2FsdGVkX19NWoSvcryn8k41upKVx73lPHyU4lhJ4Gc="
        }, {
          "num_cand": "U2FsdGVkX1+9PP8TaDmlXY83G+34IIc8pWSONHhNYl0=",
          "cpf": "U2FsdGVkX18cQVc2KJezcCbRzu42K0JWz01DIBNHYJc="
        }, {
          "num_cand": "U2FsdGVkX18G1SGjrg/cs6YixxO08MgXfoBjpxMNiQw=",
          "cpf": "U2FsdGVkX194dcmj4HBqAzMSHPR1+UBOOU/m0oOfuW8="
        }, {
          "num_cand": "U2FsdGVkX18Odr+wib4I1NCfKXRQgsgpQ2KC/p/YOAc=",
          "cpf": "U2FsdGVkX184HvCqBkXbe0ljdTGnFHL69Mb4VPrrCm8="
        }, {
          "num_cand": "U2FsdGVkX1+gtFb3X4mVJiwiqDH20e/Pt4h0FH6tCks=",
          "cpf": "U2FsdGVkX18PkNUakcTroVS+ynVc4G2NhbLdHw03nQY="
        }, {
          "num_cand": "U2FsdGVkX19g3xP/d643SycAWjsXofihyLelyMEOGi8=",
          "cpf": "U2FsdGVkX1/s0zow+33ax5MMFWrmDbAjoJINteHdKb4="
        }, {
          "num_cand": "U2FsdGVkX19iYVgUcV+7KPxo2oiQ2MKvvHWw+0BxElY=",
          "cpf": "U2FsdGVkX18PveyGW3jWq3fGaphDbA3bxq9WpkxoB6A="
        }, {
          "num_cand": "U2FsdGVkX1+OdEzHml5pcLrX/UGV7jEP20ISskKAhIg=",
          "cpf": "U2FsdGVkX1+Gbsp+hnHNl6/yELXk4Agi/ZwCRy71BNI="
        }, {
          "num_cand": "U2FsdGVkX18REDG4vZjiWXxYnGD9lI57IklgUat9MU4=",
          "cpf": "U2FsdGVkX18wyM9vRBJiaRebI/x+LhyqguT0JoB0BDM="
        }, {
          "num_cand": "U2FsdGVkX196y3c6U4pXb8dreYLfXKoYWYExr2Y99Gg=",
          "cpf": "U2FsdGVkX19J+Mx1AYt3IIZAje2HmaDQMH+sc1R/WRg="
        }, {
          "num_cand": "U2FsdGVkX1+8GO0GakAG/a8B6x7aNwcLz3ZflZXEICc=",
          "cpf": "U2FsdGVkX18zR3ZQZY4NfSOKe0WBXRbHI+ZLURXVPe8="
        }, {
          "num_cand": "U2FsdGVkX1+ISv6pEbj91204gTML5/5LdfsIf0knggg=",
          "cpf": "U2FsdGVkX18wDnXO6vOdj91RZQtZVAs1NA4EuLAOF7U="
        }, {
          "num_cand": "U2FsdGVkX1+aIxwcoGK3JkS9QV5tjWYthTuR2a4tlEY=",
          "cpf": "U2FsdGVkX1/Sjre9i3Zt9ENgDc2RLFwkom78r+aw4wU="
        }, {
          "num_cand": "U2FsdGVkX1/vRvxLXWsVenNnrsBRQOjZOcNY5g/qAJY=",
          "cpf": "U2FsdGVkX1/YO76I2KGcyPK2xIfkhUtrviCzV2V7Kqo="
        }, {
          "num_cand": "U2FsdGVkX1+fPPVwEIruWJky04mhxK053GV7S8gYzlg=",
          "cpf": "U2FsdGVkX1+FK8mh+J2VcMpnQIFdm6cX2O6KzBrLbcs="
        }, {
          "num_cand": "U2FsdGVkX19rpe82DIGGeQgcJknqEb9LQ4VTFZKNzMQ=",
          "cpf": "U2FsdGVkX19583yCz/5FnRVRkuN3BGCckNbnKAmFCw0="
        }, {
          "num_cand": "U2FsdGVkX18yixG0fgFSl5tF+Sz4lWDaU01THOl3J1k=",
          "cpf": "U2FsdGVkX1+GJoQNJRn5Nn8TrfR5BOMejKqNHGaVbGA="
        }, {
          "num_cand": "U2FsdGVkX19Teeo/0+Tsf8eUxjeQxLz/RUKS7zvdLR0=",
          "cpf": "U2FsdGVkX1+qI51ImCUk2jGyx+xuWCuMQTjUVcrJMmA="
        }, {
          "num_cand": "U2FsdGVkX1/9ec11liJDktbH/WtONJAU2BwYgIYUMt8=",
          "cpf": "U2FsdGVkX1++ZZjd9RURDbKx2vB/iE6Z1NfoiEq14F8="
        }, {
          "num_cand": "U2FsdGVkX185f0jkemx3fenPyAsELzJ/nEVfH7RwK8w=",
          "cpf": "U2FsdGVkX1/6SMq5Xk0eG/IDl74k+cyIBaPcr4cuINM="
        }, {
          "num_cand": "U2FsdGVkX1/JcOsMJ37JM7YFTBkOZqkzaAH8hZraWcU=",
          "cpf": "U2FsdGVkX18VAQ3hJNR3HXV+4tS0MSpGRFYxWgRXf7k="
        }, {
          "num_cand": "U2FsdGVkX19AlK56Cwy+urcNhw96RdVh9Y8sDcBKVwo=",
          "cpf": "U2FsdGVkX19Skw2b0JzReVpB2v9norntMCOtX1EezGM="
        }, {
          "num_cand": "U2FsdGVkX1+cRgEPZNPJFrRQEuljD9ZuxdMifKaE1qg=",
          "cpf": "U2FsdGVkX19m4W94A/vFHEHI56++BME0sT/hozXImoo="
        }, {
          "num_cand": "U2FsdGVkX1+nfFF+kya/6WSwAUY3f8mqUzXFZ68HzTk=",
          "cpf": "U2FsdGVkX19jMU97SUeU86g0+hR22dW8b8tjyTaEZ7c="
        }, {
          "num_cand": "U2FsdGVkX19XTyqIzTGNi2XpyhyIRERw4XYa63tg5xw=",
          "cpf": "U2FsdGVkX19HtqxxCL3AIZr2x5LV3GBLjOoAEXsu38Q="
        }, {
          "num_cand": "U2FsdGVkX1+szMgcEe/VDap7Sqzsz7SrlpvviGVYDvg=",
          "cpf": "U2FsdGVkX18ItZGQMRqE+oE0OqpNGxYgTuXw6OnuOd4="
        }, {
          "num_cand": "U2FsdGVkX18r3qS/fZ+e+pzRUJHdk43SjbjR0mDDRV4=",
          "cpf": "U2FsdGVkX1+meiZ5uHYMn78Hq5l2mw/NqfaoQmwQVo0="
        }, {
          "num_cand": "U2FsdGVkX1/ECvbI5l0U+Tst7VZtVlMoROU2/BHlGZE=",
          "cpf": "U2FsdGVkX18c2bdXk+D1aF0LgoQtRFz0TFoy5YrIDiE="
        }, {
          "num_cand": "U2FsdGVkX1+8WbphQcJsVJYO/XKFtDfSy3XTo6FRl8g=",
          "cpf": "U2FsdGVkX1+EDs+cPDBeW4wmTeAemcyf3RRgzhli+AU="
        }, {
          "num_cand": "U2FsdGVkX19zAz1y1cipyiKvOnMCa+38sPWRvLKi14k=",
          "cpf": "U2FsdGVkX19s96hQQ1mhBaQ/a7J4XfsZXeBnFfyi+MI="
        }, {
          "num_cand": "U2FsdGVkX19C/IVDhxwMyvOZTOSpsV63MhQuPiuietM=",
          "cpf": "U2FsdGVkX18zCSp8gZ3mvCD10qeg3YX1fJ4hu42bUUc="
        }, {
          "num_cand": "U2FsdGVkX1/AhvHTjFPMIsulqqX78fm+2QDNfUQeqks=",
          "cpf": "U2FsdGVkX1+malmav7KbCaDZQR185gAodV9IWnKH/U8="
        }, {
          "num_cand": "U2FsdGVkX19jV5JYfz00z9H5+MTJTJVO9XnWVrlMjKo=",
          "cpf": "U2FsdGVkX19ixXKVkeDhay6UnTdrS57qG4xgpQ3V5Js="
        }, {
          "num_cand": "U2FsdGVkX1946AWQJq1pA556vhYTBk31fW+bui4yro4=",
          "cpf": "U2FsdGVkX18oCpHmLV4Bvx8wX1PMH+wNMlzy/ietj2Q="
        }, {
          "num_cand": "U2FsdGVkX18q9/iTPw7LyLyJm/kjIu5tPY4oQBOagFw=",
          "cpf": "U2FsdGVkX1+yBvb+q6sUlZP6WPOAClnBC6rHXtS5aIY="
        }, {
          "num_cand": "U2FsdGVkX18/O4MQVjObccX6C4R84pr3rYc4HGTol8s=",
          "cpf": "U2FsdGVkX19qJy9Rq26PE6Js3YmlbEm03yj+N+A2djw="
        }, {
          "num_cand": "U2FsdGVkX1/bV+1eCN9kxryH3JL32wuY+Rfgm3KdItE=",
          "cpf": "U2FsdGVkX18B+katsCfU73aj0JFrhmWEUwC3bVOM0Sc="
        }, {
          "num_cand": "U2FsdGVkX197EdsKF45QV9QSSEfs4QRpJePoTvRV5us=",
          "cpf": "U2FsdGVkX1/MFVHibRh6BSKlkqm7AyAvL8ANv7H7u6k="
        }, {
          "num_cand": "U2FsdGVkX1/a5LA7VQgiIjzugXzs5hOyvI/Lyqp389o=",
          "cpf": "U2FsdGVkX18F57IsF7ayhU0X08i945EQku18KBJ/UPs="
        }, {
          "num_cand": "U2FsdGVkX1/Novb6oUSOQrQZ6EJpAonK3yoXqfbUWak=",
          "cpf": "U2FsdGVkX19OL/gI2i45XcGh4odv5iBsxRbbLy9aJi0="
        }, {
          "num_cand": "U2FsdGVkX18jhe94FzKUXwzOui10aDL5deicyYmVSEA=",
          "cpf": "U2FsdGVkX1/PVYSnzX0h9gdIKIBageGZuT1IqkOydfo="
        }, {
          "num_cand": "U2FsdGVkX19Bc/6q8OSFUlwRxykY2dcZT37bB5J2SuM=",
          "cpf": "U2FsdGVkX1+aJshexJVVgArTZw4mY6X/b6Vz2C4LT8U="
        }, {
          "num_cand": "U2FsdGVkX1+IwyDZ3rE/3sLJwc2NQXpIstMnOpX/xjI=",
          "cpf": "U2FsdGVkX1/tJCsW9INOe3GHUKStCEBNovrGnuYv3YE="
        }, {
          "num_cand": "U2FsdGVkX1+lCFeH2Fd7Szfc54G+Iw3sefYR2mIMqlY=",
          "cpf": "U2FsdGVkX1+fmXsFhubrVj8aT/RX6KaqucvwkF+t4Z8="
        }, {
          "num_cand": "U2FsdGVkX19ZeSGiaCo2m0QOQz5sO3zPpoUGi7c7kLA=",
          "cpf": "U2FsdGVkX1+0zlT1wdv7XSWglx5SW7BzC0Di2wN8q64="
        }, {
          "num_cand": "U2FsdGVkX1+eX/IYRUbq46CaV0QQGAc5m6cbfjeJU6k=",
          "cpf": "U2FsdGVkX1/8p97MjvqLgPUVefMXPfNtPBxon2rg17o="
        }, {
          "num_cand": "U2FsdGVkX18t4l7v+8OD5Fe5P8wnRysuean5zcYvmok=",
          "cpf": "U2FsdGVkX1/8WktKP9K6tN/Vzq6/qgSBBLNG0sCzL5g="
        }, {
          "num_cand": "U2FsdGVkX1/Z4Dv9Pm+XH28I7nACTEcjFC6BZ+9Oh0M=",
          "cpf": "U2FsdGVkX19ezwcmanIbXcfcL3jdcnSk6p8onXWl3eU="
        }, {
          "num_cand": "U2FsdGVkX19la012WUOm0Gsj3Ghqdsw5BoA6c4cf2Wk=",
          "cpf": "U2FsdGVkX18flcx35BH8YVf/NWy72Ba2D4VbTzUolW4="
        }, {
          "num_cand": "U2FsdGVkX1+oioeMWCHOeun1Td7fuj/Adl1eN0NIjvA=",
          "cpf": "U2FsdGVkX1+HptvoQgO+N26PLucCNAAjdXLlqMDYruk="
        }, {
          "num_cand": "U2FsdGVkX19oRHpeJPTNWNQEZ/TkKgP/fpTVYAGjdXU=",
          "cpf": "U2FsdGVkX19r/4/bMZ+qa+V5no3sMWfSIzmhz6kvTgo="
        }, {
          "num_cand": "U2FsdGVkX1+h3tYe2/t/XfbQ9pZ3fKXhBmVdBPuAhgE=",
          "cpf": "U2FsdGVkX19mcD9vCqmFKmt2Mpyx1JkJiHCA1IZZBr0="
        }, {
          "num_cand": "U2FsdGVkX1/lsuHmHVUmDaSmHlTbco+Ej5aZguZpndI=",
          "cpf": "U2FsdGVkX1+BSSQw9S5/PyoZ1ogV/yl9eiaBETIFcaU="
        }, {
          "num_cand": "U2FsdGVkX188o6bdD9/Sk1DMlgaM0+g8X2mRZsn5mlI=",
          "cpf": "U2FsdGVkX18unko+aq0BJNtV0DmKVsjVqY3BZQ5ffGU="
        }, {
          "num_cand": "U2FsdGVkX1/dW/ggEnr3U73YKaLZs4yLM3FyD7c6Rt8=",
          "cpf": "U2FsdGVkX1/CRdytsvN0w6HrC6/e/WoB+D99Ss2OvfI="
        }, {
          "num_cand": "U2FsdGVkX1+YST9sjIqTq9tl8wMtGbOcYNMZn9nTbAQ=",
          "cpf": "U2FsdGVkX1854QmwGXYGr7jh2Hmwb06fJaLJv57MCdk="
        }, {
          "num_cand": "U2FsdGVkX184q0eMspxwj/PuXqL3pkfH9F10W3yUg04=",
          "cpf": "U2FsdGVkX19xjnhFPx1BwQH29P9OEgiy0VASf9iAgk8="
        }, {
          "num_cand": "U2FsdGVkX186DTnqQsVb+Bm2h58fGbeZaAQCU9mryYw=",
          "cpf": "U2FsdGVkX18BMnDuG9rDiJgzeVRhfWbi1Ojd3m0DFJE="
        }, {
          "num_cand": "U2FsdGVkX19cxpiQ2tS0JIykY0DS9/4DoXL1DoHe+Ls=",
          "cpf": "U2FsdGVkX1/RJAEWsGY2yGetExpCpWr/7EUILhCNZJ8="
        }, {
          "num_cand": "U2FsdGVkX1/teItojzBWcgtXoMDpTWiOh7exYRRUres=",
          "cpf": "U2FsdGVkX1/WHuq3oGz0lSiMblZ8CA74jEsu9kjD+80="
        }, {
          "num_cand": "U2FsdGVkX1+BRfDZCGcy4Izl39m8CNv11nMp22VedEE=",
          "cpf": "U2FsdGVkX1/F0dctdDu+7m6+p81v606CJcxjSADdGUc="
        }, {
          "num_cand": "U2FsdGVkX18eI0/HPDE6lBx7I24hylFjwKzQ1iBiYyw=",
          "cpf": "U2FsdGVkX1/6tK5qIhbmyok0SS2mC5BlFGJMtijEfZY="
        }, {
          "num_cand": "U2FsdGVkX1+Il2nxMsBiaqXO0TzZxztydZVyo/Kl03Q=",
          "cpf": "U2FsdGVkX18iDNcTpl1LfnYVYhMkuLr8tGFrn6Q5Sgs="
        }, {
          "num_cand": "U2FsdGVkX19jU94jRGr07eE94/0gss3TejRufBZDXxw=",
          "cpf": "U2FsdGVkX18lpYdYE70eXVjMPNP0QQhf2LWy/S9kMg8="
        }, {
          "num_cand": "U2FsdGVkX1+65JnlTkiEsyOTUDbCE3z4pn+tvnxg7m4=",
          "cpf": "U2FsdGVkX1+jMjPqTzhDz8dxHVB/+8lo3DHYnBv9wHw="
        }, {
          "num_cand": "U2FsdGVkX18OIw4ij7AZb42Cn5UXPP3DhpZCRoBG5Wk=",
          "cpf": "U2FsdGVkX18QAcby0WJBXKrdYg4rDlKn5hYLjHwYl8I="
        }, {
          "num_cand": "U2FsdGVkX1+BBEZOcbuPtTTszReYpZjrWAUXGAVbBx0=",
          "cpf": "U2FsdGVkX18yXn0RPYZK2b3LAtVFb7ZaZ+XX04DdQT8="
        }, {
          "num_cand": "U2FsdGVkX1+/XC61lkUJYvHm1lKPAbIhYW8BOe3N9qQ=",
          "cpf": "U2FsdGVkX185XZ/eD/2eX3RbfzDQt9rTyppAEH5+JBM="
        }, {
          "num_cand": "U2FsdGVkX19AEhvW/V+aCG39ptUXDf2GLscMMabLC7U=",
          "cpf": "U2FsdGVkX1+cwdzLSPmpC4RR/YDf0aFEzpshiM9zavM="
        }, {
          "num_cand": "U2FsdGVkX18HCl0J0gyQgrO9TucHrXy3tD6snxPRSkc=",
          "cpf": "U2FsdGVkX19oAOf9AjQTbz8V2P4WT8sQk6CCVK+42ig="
        }, {
          "num_cand": "U2FsdGVkX19IEge8uAxWTdIOuU6QKHI9pJ8a5V6v/nY=",
          "cpf": "U2FsdGVkX19aR0dWmmDwdPsuE5dRLCvUFjRBh77UYNE="
        }, {
          "num_cand": "U2FsdGVkX18lvdsMtY0rb9KVls8ZvHf64qeGKQWD6lU=",
          "cpf": "U2FsdGVkX1/EVUtAsiatMU1QoE3ZB3Pub/jNiZNWGaI="
        }, {
          "num_cand": "U2FsdGVkX18hx6ZwKaY70DQjT9vTTuMZ6uVj0TN1oZM=",
          "cpf": "U2FsdGVkX18rjKyqNPzwqX24zcoxlqoSbpAvXA9h04c="
        }, {
          "num_cand": "U2FsdGVkX18FLi+Z3IQaZ9jyrY42CfUfPVWAgwQGsLE=",
          "cpf": "U2FsdGVkX18LF5EpLeY5S41XHh0VlVk7KEjWZ0GpO2Q="
        }, {
          "num_cand": "U2FsdGVkX1/vvmLoI6RdacjiTajTRjQKQN7ROhfOa2I=",
          "cpf": "U2FsdGVkX193kj4JrVOyBsUdze3vSq4G3ylkjIvnqBU="
        }, {
          "num_cand": "U2FsdGVkX1+KBQVEPVs3xb/cDu7El34kHaa7zfaQa4A=",
          "cpf": "U2FsdGVkX1+sOsWkI1abYdClIkl13+eDTKyIc+UU5Dg="
        }, {
          "num_cand": "U2FsdGVkX18VexvgZvNl8TE/YSd0dxFj7DIs6RWY0Zo=",
          "cpf": "U2FsdGVkX195VhqdZEl0SAdcdL6i4Dh0/K9WXhUyTHA="
        }, {
          "num_cand": "U2FsdGVkX1//tR/rl3pKutcHEZ6OfGlfuYv7B68kaRQ=",
          "cpf": "U2FsdGVkX1/dlnh0jYuWWNu/+8mKL8PkWO2ACZaLYnM="
        }, {
          "num_cand": "U2FsdGVkX180M8vmrknW8YCnsrs7UchEE7Ld/0/lCL8=",
          "cpf": "U2FsdGVkX1+dbx/Rd5LZdfUsRSHfVtALpS079gvMZh4="
        }, {
          "num_cand": "U2FsdGVkX1+tA5xvL3ElWp3KS6uXBY9Q4kDwpCjKJXE=",
          "cpf": "U2FsdGVkX1/PKkhKnPQ4F4dQlvKD4MphYoKhMOaMSBY="
        }, {
          "num_cand": "U2FsdGVkX1+/xNgX/hg4M9Q89DQMEu0py2jDl4b9YaE=",
          "cpf": "U2FsdGVkX180cjGa1+ZU+LPnAfwPUjiWcngjUMl/XpI="
        }, {
          "num_cand": "U2FsdGVkX1+bBiwsLHKnEkMhX7f89NntP0/K9PtqQR4=",
          "cpf": "U2FsdGVkX1+O+S5ba3INeMDx6/AThsWSDajIa2UBR7Q="
        }, {
          "num_cand": "U2FsdGVkX18e96S5TztPFbG5MHz0SqvFA0ZXHPaPuQM=",
          "cpf": "U2FsdGVkX1+NNNWmrsqnPNZX/tSZXk9wKWIizlz3q88="
        }, {
          "num_cand": "U2FsdGVkX18vGCKSxsBkT2DL8Yx0caZJ0R0TDjq5iC4=",
          "cpf": "U2FsdGVkX1+koslJf9jLjVMiOpTQBwmLXzlvk6Oi8E4="
        }, {
          "num_cand": "U2FsdGVkX1+GaEBiHYL0/MTChXJWOXv+W798L75kHJo=",
          "cpf": "U2FsdGVkX18s0or9beuCxeV0UYA3lPWEUAkqVwKp9XA="
        }, {
          "num_cand": "U2FsdGVkX1/dYQfE4Sk1q49ttfK/OUZVkpTGe/MImeM=",
          "cpf": "U2FsdGVkX19GdfZ0C2GQg7ILQww3Kecjxb3w0XNA/7g="
        }, {
          "num_cand": "U2FsdGVkX19i1lyZ8jkp3DGlwLDJZrUx5jEcbYH9W7A=",
          "cpf": "U2FsdGVkX18XegZ2mDBmkmni/CHSbZTBs6s0aI0eIdo="
        }, {
          "num_cand": "U2FsdGVkX19vPR5IDaPXDiCNj1yWCZXFPle7Hd1St8o=",
          "cpf": "U2FsdGVkX1/Wvf64UpECDMtmxH0Yx+zPchq/CIDiY0s="
        }, {
          "num_cand": "U2FsdGVkX1+bImX8a3D462EpfXQKKRGXk7/0Nv87vbc=",
          "cpf": "U2FsdGVkX1/E+yb6EkgFx7DXHjd0XYrdfJpjWzCj1qQ="
        }, {
          "num_cand": "U2FsdGVkX198YeamUwEO8P/djUvdrddPRFTMSARnPIU=",
          "cpf": "U2FsdGVkX1+z5g9vDB1wNvwnBR4bNPbJFW/XXFsQBd8="
        }, {
          "num_cand": "U2FsdGVkX1/EzSNONa/IyxsedsaxPTlveZObsMSV0og=",
          "cpf": "U2FsdGVkX18qCgWwkRCrm8fINOcfBpNSomsvTuUpyJs="
        }, {
          "num_cand": "U2FsdGVkX18t1gbz9xKKATOekgOOIUK2/XcoQ4xwACM=",
          "cpf": "U2FsdGVkX19KYZkn0MPD9Cwq52vHZ6ilqduISV7Deao="
        }, {
          "num_cand": "U2FsdGVkX1+LyOEWxqHPyShTal0pg2rnAPRCq2JWyX0=",
          "cpf": "U2FsdGVkX19xwiLrzFOEopXIs6n44io8HbVq6Blf1DU="
        }, {
          "num_cand": "U2FsdGVkX1+i00Qkl6Asy1YhTN+4JL8SBF3/qj5cYU4=",
          "cpf": "U2FsdGVkX1/fHkCrl2I/cZtERRAp52P7MgXUUw+wUqo="
        }, {
          "num_cand": "U2FsdGVkX19MNjzrSH5jNwaN+I53//yQtE6ZaToHGZg=",
          "cpf": "U2FsdGVkX1/O+5wBWR5G3Es3M+LUlM3d2OV2JCtdHOA="
        }, {
          "num_cand": "U2FsdGVkX1/4Gp1Jwm+5WulwuozZUFeCCZnfyhnMTRY=",
          "cpf": "U2FsdGVkX18NKU3mtyWkon6unkPlgsBm8UcTB5dpp2s="
        }, {
          "num_cand": "U2FsdGVkX19dUnNAsLgWpbgin+fbF8TIAb0gabJHncE=",
          "cpf": "U2FsdGVkX18GAWl5gwsMddgjk9T1RTqcZpyoai8Iw1s="
        }, {
          "num_cand": "U2FsdGVkX18Y0W3OmV4Zd6shRMUlirPACvmTrEP2SIM=",
          "cpf": "U2FsdGVkX19i+Jn0B5gbTv7r9kVAO7x0OCv1JV7ubmg="
        }, {
          "num_cand": "U2FsdGVkX18txmOf6mSbmuuUTx8gx4/izooFBepwsc4=",
          "cpf": "U2FsdGVkX19Qma4Vnh4eQRO3R/DBnUVK/E+hH/c2OnA="
        }, {
          "num_cand": "U2FsdGVkX1+Kh1P15XwneP3k+Y9BjbyEjVxx9xlBJuk=",
          "cpf": "U2FsdGVkX1+cXmv7CRBQQ04LD98z1Mdq4ZBWzLClOro="
        }, {
          "num_cand": "U2FsdGVkX18gCBFL96PPICPhhb+qqp1otZ+axpAVmnc=",
          "cpf": "U2FsdGVkX1/qlE14qF0nUB1RahvR5678AeF5d9jbkc4="
        }, {
          "num_cand": "U2FsdGVkX1/f4cD1BsENPpMNCXfX2ZELKPiTc2YOE8k=",
          "cpf": "U2FsdGVkX18hM9guFwy18v9CrXYvZ6Sk/KAentac2Yg="
        }, {
          "num_cand": "U2FsdGVkX19xDpvAY/UC4q90iacqbA9twGIunxYNuIc=",
          "cpf": "U2FsdGVkX182/9HOGxEApl7Cd3zCxVjGvSLianBeBHQ="
        }, {
          "num_cand": "U2FsdGVkX1+oa6AZ0lVWxK3kNeLFdneinBhsKHWupa4=",
          "cpf": "U2FsdGVkX18OzIO1Tb3gOO99hmvZD5X2KG9GfIW6q2c="
        }, {
          "num_cand": "U2FsdGVkX18u7WTjRaiCmoU6C7/QlNBkSjwrJCWcSwI=",
          "cpf": "U2FsdGVkX1+Z2WuCYTAdv0tzF95vd9Lm9gBs/sEcZGs="
        }, {
          "num_cand": "U2FsdGVkX1/jF04RsofOhlGDvHzj9mRWrrgRL9CfdVU=",
          "cpf": "U2FsdGVkX18Wd9jz9SQQC1/3r/XsjqrmyyhRLVgpFo8="
        }, {
          "num_cand": "U2FsdGVkX18qYnVdhPviBKK/hJuRItjfp64Ucu+QgnE=",
          "cpf": "U2FsdGVkX1/+cf4Om4X6QpFAmw7gMgVK3ZQ8D57xcWw="
        }, {
          "num_cand": "U2FsdGVkX1/KngbseLEr8waWbOBjLH7TO5UqluuLCRo=",
          "cpf": "U2FsdGVkX1+ygvrXHJLv6Hq6Se9wlkWUL6f7GvhUNNY="
        }, {
          "num_cand": "U2FsdGVkX1+w6Eki8EBboxQR6eh9OJxQHLK+S4YuCZw=",
          "cpf": "U2FsdGVkX1+0cqJvzbzL2R6tkm50yxYRDY2UtzQbP/o="
        }, {
          "num_cand": "U2FsdGVkX19NIUUlNoevZv0/q4o0qVRJOrzblIZaSH0=",
          "cpf": "U2FsdGVkX19HsKMjVsfAW9wLrnGp5av0fOXZ8doLbok="
        }, {
          "num_cand": "U2FsdGVkX195it+PUTssgj7vmf1+UnFH/XJnR1OZYCg=",
          "cpf": "U2FsdGVkX1+3DU4NFDQrOZm+Y1Mdp/YGv/G0V3rcUBI="
        }, {
          "num_cand": "U2FsdGVkX1/UmkPDrfIupt+YL07RY4ykZFAVwqfOMd4=",
          "cpf": "U2FsdGVkX19YR86/JASfz5OXoaAMoHEDtEqtotGSitQ="
        }, {
          "num_cand": "U2FsdGVkX1/oQia8gsqA7c9YkztRKNPmrWqSHsKtbv8=",
          "cpf": "U2FsdGVkX1+Uh1Dn+sidvuh+0B2ajmj8RxyiFW5RkPg="
        }, {
          "num_cand": "U2FsdGVkX190TrFKleEZTh5qJBQFnDMAU9wmSUDM9T0=",
          "cpf": "U2FsdGVkX18sofvbtm4GcfS2XrlLxFA9y/8gZXDnhEc="
        }, {
          "num_cand": "U2FsdGVkX19LlDKc0850PT511stD1t8NgHQByG7aRHk=",
          "cpf": "U2FsdGVkX1/zCS2PLF6ZUCpKmclHb9FXJ4CHOwdad6A="
        }, {
          "num_cand": "U2FsdGVkX18wc9dxDgc3eQn8nxAWNAj+q0HRNNa3dk8=",
          "cpf": "U2FsdGVkX18vHLgr50QqfBWSxoVnHdv3QUlqHM9sNBg="
        }, {
          "num_cand": "U2FsdGVkX1/rx9n5LGnSLd5OF+jT7GaLj6h51jJuxEQ=",
          "cpf": "U2FsdGVkX185tUnk7FvKwa+JxlnpXebP7+yxqSmJGSU="
        }, {
          "num_cand": "U2FsdGVkX193MtH/+dABnNEBPNO/qjZI/7nMEGCh5BQ=",
          "cpf": "U2FsdGVkX189uzd2viyRM3Q5aiRYXTtFRrSlXsdjiMQ="
        }, {
          "num_cand": "U2FsdGVkX1/A2fGfW6oUfsGlf+dypHrIpq9RyVdGZb4=",
          "cpf": "U2FsdGVkX1+uFCFpj9V/XdbnoNjgmWhJIoIZe3L60tU="
        }, {
          "num_cand": "U2FsdGVkX1/Y9lrbIFm/oV8QtdHhQrkU8hMEhfhMpYk=",
          "cpf": "U2FsdGVkX18EyF0h8PIaedQsSn3ISJ2oDtB1kvdnSyk="
        }, {
          "num_cand": "U2FsdGVkX19d/clE38o5I+Ehp5sXCVNgKYW3KHh8Yqk=",
          "cpf": "U2FsdGVkX18uXXp+aUgOV/SysgVwR4il9Ji+HTA8/b8="
        }, {
          "num_cand": "U2FsdGVkX18O8eHd3SnUCa+k5wxr3lS1fPhrobY0ZJU=",
          "cpf": "U2FsdGVkX18tVIeEXZpJJfXfA28rZMzdr2JtLi7cDUE="
        }, {
          "num_cand": "U2FsdGVkX1/0Bs2/GM9CTGBWIM6BxHoEoPdVwdT4aWY=",
          "cpf": "U2FsdGVkX19L92mLtwpTc6xiEFrTC6JGp0wMCu2B88k="
        }, {
          "num_cand": "U2FsdGVkX18IR/FRjHA+9qJK9c5yccHyKMrvpavghgA=",
          "cpf": "U2FsdGVkX1/8rkavHgK7PQ7izPcRa6LGVoBcAcgIiFw="
        }, {
          "num_cand": "U2FsdGVkX1+2o7Rl1eE74sGbPkkR7xWyyMMpJ6r0+3M=",
          "cpf": "U2FsdGVkX18yrV65bUMByiFuFe+Vb3LZYpbqwNizCg4="
        }, {
          "num_cand": "U2FsdGVkX1+yciLYzWjOCqL5Q5XVJxuoZsx24gRoyeU=",
          "cpf": "U2FsdGVkX1/fES/Q0QnRVO3RJ+Tg0tUhl+ORjTI79jE="
        }, {
          "num_cand": "U2FsdGVkX19rHqSCmenjJ9f+s6ZI13noZGBTgaW3ZMg=",
          "cpf": "U2FsdGVkX1+mTFqd/m9MOnce6F3Droy8C94rWNZdxvA="
        }, {
          "num_cand": "U2FsdGVkX1+0sPmkEfwUQdGJc5Ld6/naI+TRqnsC6iw=",
          "cpf": "U2FsdGVkX19RN1XFcEKZjz/eU+1Kz45taijSR+qeIvI="
        }, {
          "num_cand": "U2FsdGVkX1+Kqd3zRKNwMP1mNx1s+4NZ4r3vxr0wFsg=",
          "cpf": "U2FsdGVkX19d2EBH8YfPxBntZvkC/rH5b+Up2+yE+nI="
        }, {
          "num_cand": "U2FsdGVkX18rte6kEobL4MuWG7vBCUf1dS/ugf5O0gc=",
          "cpf": "U2FsdGVkX1/HobG+cjwbuqb2fRnJafQ+0G0WHjbJSMg="
        }, {
          "num_cand": "U2FsdGVkX19dXXBzN6156MWfS6AwzGsDENiogaq1AGg=",
          "cpf": "U2FsdGVkX18VhS4iPWLrPCBszLHie7bpyNuRhSeP5Q8="
        }, {
          "num_cand": "U2FsdGVkX1/tduQYDTH9/EYncywz09oubvwc0CnaJTk=",
          "cpf": "U2FsdGVkX18AdYHfAK/chy0X7NCDxfPjt5rs+uqdTT0="
        }, {
          "num_cand": "U2FsdGVkX19qfnQIe+buBhznIeK57Xwndf0830Yz94U=",
          "cpf": "U2FsdGVkX1/bJA/2eByogzXaLF/NKOSPh4xUf68Qrb4="
        }, {
          "num_cand": "U2FsdGVkX1/IR40RI6CqvFQ8jgs9CilPCPECAYi5QDA=",
          "cpf": "U2FsdGVkX18PTR5R152dP/VdmCe6N33Spoyru2PZr5w="
        }, {
          "num_cand": "U2FsdGVkX19mZOdlmTbElsjYCoGzttLC05ChXkopYJw=",
          "cpf": "U2FsdGVkX1/LkKFMe5raRTDdakGzPJGXfaB8WPQSpMk="
        }, {
          "num_cand": "U2FsdGVkX1//ZSbCI0hg60wHH5HuZWBjRFeoJ+90UfI=",
          "cpf": "U2FsdGVkX1/Ou1C+7SI7Ra6gWxUE01Fp1BM3JhsBMB0="
        }, {
          "num_cand": "U2FsdGVkX1/VjPb4odO+m+g6qec1FfyLNbW7e9m6Wyk=",
          "cpf": "U2FsdGVkX18IvLBlobZjISwqeEbryOFHMEw9iUBKyNc="
        }, {
          "num_cand": "U2FsdGVkX1+OZDCE1TMq/vcFDFDsmjGAMszxm9fzsn4=",
          "cpf": "U2FsdGVkX1+zLbLWcJH1GqHhkurf6ZcIPacHmI5AtMI="
        }, {
          "num_cand": "U2FsdGVkX19FKOIG2/ZSznX2YDpFeA1bP6LfAnahOr4=",
          "cpf": "U2FsdGVkX1/9XJ+RcgJngt7tPPa/qZriZSvU+M89pS4="
        }, {
          "num_cand": "U2FsdGVkX1//lz1ikIp+7MQC5b29Zag2g3q8Tv7EyCE=",
          "cpf": "U2FsdGVkX18KqoX2fVA2H+W7Zd2x00KZ8G2rNcqSJR8="
        }, {
          "num_cand": "U2FsdGVkX18+Hr7tc6F5/RoRH8dcwROW3EX/8fyUuaU=",
          "cpf": "U2FsdGVkX1/ALZcKRagNE2Q/PlEtw3Y5DpMkZ+9Y6gM="
        }, {
          "num_cand": "U2FsdGVkX19FZrAiGOeI7iv34jX5nHfRMCi66MPByQ8=",
          "cpf": "U2FsdGVkX1++J9IrpFV+PnlGDccFeiY/qSXHSdJdoTk="
        }, {
          "num_cand": "U2FsdGVkX1/CFV4gcD1HsHesMlR8+385ao9CsH/LCkE=",
          "cpf": "U2FsdGVkX1+OFthNhUz72YC81vzY5vulihe4RtlDYUU="
        }, {
          "num_cand": "U2FsdGVkX18HOp1TLkqCMgQ0+5aW1t1sSDMg3lH2jD4=",
          "cpf": "U2FsdGVkX19ugotMQp+6f/QsMVQeilaNbcmjwVDjB34="
        }, {
          "num_cand": "U2FsdGVkX1+kxwxOt37xFbnzMFa5RuiHOd2zfmGdzy4=",
          "cpf": "U2FsdGVkX196dBHne7dqam8Cwxvg7R5okqn5CXWaxQo="
        }, {
          "num_cand": "U2FsdGVkX1+gJi9SFqE2aKm9tpx0ZAEcCmcbD16X1/s=",
          "cpf": "U2FsdGVkX18kauYI4R7B4UgEEybgW3AuopH+E5sz3n0="
        }, {
          "num_cand": "U2FsdGVkX1+7j0jt7bNl2hG9VT13OIve53FAeW1njEI=",
          "cpf": "U2FsdGVkX18zs8pLoKEcYxSaq0101OX0f3cWoV6WjP0="
        }, {
          "num_cand": "U2FsdGVkX19Fe7JQlU0pIW4Uk+O/5vhlWyT7o5XI72g=",
          "cpf": "U2FsdGVkX189HfDK5V6y6OYpQTjDe1z2J4Mzerf/wJk="
        }, {
          "num_cand": "U2FsdGVkX18BudwjukD6lcYr0120uDkpKcDoYW3RFNU=",
          "cpf": "U2FsdGVkX18eLAWv4LT0qwItvy4VhKcopGYu7qnmQCM="
        }, {
          "num_cand": "U2FsdGVkX1/4lJ1S/33stGLq6o2sAb8X0GCCimZZxUM=",
          "cpf": "U2FsdGVkX1+S1YzbaLtgHpJ7Y25G40HDcW0bOPoXdSI="
        }, {
          "num_cand": "U2FsdGVkX1+fobmmNbg9ZldNTrPawBlgv4XnWE86Az0=",
          "cpf": "U2FsdGVkX1903Vxiun6kkqTvSRq7DC85jDN+TBCRY08="
        }, {
          "num_cand": "U2FsdGVkX18r0VxxL75Es/7AYS4oOL03TCAWi4Y6hOI=",
          "cpf": "U2FsdGVkX19gdIcFoVUdwFDpKqmMvGp8BCjmPtFSAUQ="
        }, {
          "num_cand": "U2FsdGVkX19ZTtODeQkjqQnFekppOcOcYUH6yuuf/eI=",
          "cpf": "U2FsdGVkX1+ftmztoYbsRwQ7cyOWHJ2jiMkQMYuzc40="
        }, {
          "num_cand": "U2FsdGVkX18XXn7+imutun3UEfVfIL7J9Su1cBIyV0g=",
          "cpf": "U2FsdGVkX1+cXhMTtcMdy+udE5gV3OTwaI8UfEfdyDQ="
        }, {
          "num_cand": "U2FsdGVkX18/JNuwvB1MTrd4jZtnp+hdWDwI69F11bc=",
          "cpf": "U2FsdGVkX1+t5LcyFiKUqbVrO6+aEboG3gXPXwFRGF8="
        }, {
          "num_cand": "U2FsdGVkX19xu81MHfeWzQdEtr8XN1Fs/EZ8kgCy/wM=",
          "cpf": "U2FsdGVkX1/d53trrFCnDKX/3YQIi0DWnR68XfaFI9U="
        }, {
          "num_cand": "U2FsdGVkX19w8avJxO2AWcD9pDZ1f5GPpOVjHrgFjOk=",
          "cpf": "U2FsdGVkX18UK2fPGhzzCYxn20VfZ8fRViy44nMOVVk="
        }, {
          "num_cand": "U2FsdGVkX1+kHSG4FT4KSCH+QPAmoKT7vje8ZXcF7l8=",
          "cpf": "U2FsdGVkX1+2IbDoC0U7LCnpGgQxowKc06Ft5UxH9lA="
        }, {
          "num_cand": "U2FsdGVkX1+qFWs56cG43wICHA1fZgg6XfwaLtgYukQ=",
          "cpf": "U2FsdGVkX191jzf8wKOFBmdpvVhojlh2oBeBhpv08zk="
        }, {
          "num_cand": "U2FsdGVkX19938rCvy26KVQSjRkMB4Vs7yn7vpJ/FXw=",
          "cpf": "U2FsdGVkX18Ac4Xq0gJFtcBGz8bNMgkkKOrseZAwhkg="
        }, {
          "num_cand": "U2FsdGVkX1+tGvNJ/A0VikivmRuu6l8dgIBZ2FWzxMY=",
          "cpf": "U2FsdGVkX1+aeQqcN6Y9OEnGCoIu3gRJh33Fk6jb4nw="
        }, {
          "num_cand": "U2FsdGVkX18ergjajxicjjd+eAnB0rS4lSme8UTen2w=",
          "cpf": "U2FsdGVkX1/6eoNV78oAaX2d5pht/CRnXbmPhiikVP0="
        }, {
          "num_cand": "U2FsdGVkX1+quHcf9UwQ5GbkbUNKP+ockn7KKBE1iUY=",
          "cpf": "U2FsdGVkX18oz2huRq3sCdaC42+ant9XG2PTysighuA="
        }, {
          "num_cand": "U2FsdGVkX19sKo41h9xuAiskMXt37RQ0g7KSooFBCaE=",
          "cpf": "U2FsdGVkX1/8qGk1G3XByeeDSMxY99RSwFG7dQpExo8="
        }, {
          "num_cand": "U2FsdGVkX1/8I7dr87+HtBaK+QgyKppWXT6BcoJ5/g8=",
          "cpf": "U2FsdGVkX1+gltKEfFaMqi43Ebc0Rzy2TF+x47trpB8="
        }, {
          "num_cand": "U2FsdGVkX1/wxVwp1NHK1XUn95P/026119eJt4VMazM=",
          "cpf": "U2FsdGVkX186cVzxrmnbJcG2G2/PbWUP4uFtXcyCRMk="
        }, {
          "num_cand": "U2FsdGVkX19tCqSQAo31P8MmFE4kJAm8lydpVBY81Yc=",
          "cpf": "U2FsdGVkX1/SrbKWxQqzJndqC2//OIyMGKauQjuQrv0="
        }, {
          "num_cand": "U2FsdGVkX1/9zLk8so+hiYmy5sUIoTtp6R7LZGoGftc=",
          "cpf": "U2FsdGVkX1+BvAIc2Fc+DKAsKbR6/VW4szT9sFIfHLs="
        }, {
          "num_cand": "U2FsdGVkX185gLb7oPAtihctbLLd5hYRej8q9FpLXAY=",
          "cpf": "U2FsdGVkX19fBGFdRLRQQqThsj7p4PPfAA53PcpUa6o="
        }, {
          "num_cand": "U2FsdGVkX1/kak/i74oQj8pL8hDAsmxEThWezDPrdZ0=",
          "cpf": "U2FsdGVkX1/smZuoI5SZt9ZPUFmS0HJIZMqRJENfmts="
        }, {
          "num_cand": "U2FsdGVkX19apmv9ZIHuCWOVF+OKDeKW4NHRCOEpGWc=",
          "cpf": "U2FsdGVkX1+pKXLP31rz0R5VA/t8eP+fXnFEiAM94R8="
        }, {
          "num_cand": "U2FsdGVkX19rhAowtBfBI6UZTiEliM4YNwOuGexl510=",
          "cpf": "U2FsdGVkX19OjFcW8AdMEFWcC8uyYnTb8WaRp99S2+o="
        }, {
          "num_cand": "U2FsdGVkX197P5Klm1tCamuEq7u1YdqTIuMmyEZyZas=",
          "cpf": "U2FsdGVkX19rq88/CHwI3JLWRGdN/Ei0kmmwMDVxaxQ="
        }, {
          "num_cand": "U2FsdGVkX1/UIJWrT60n9SOj0+RvH/0Nk5hC9dOz3E8=",
          "cpf": "U2FsdGVkX18dgx9Opl8siM7FXCdxIbYkN5VgS3cbUOk="
        }, {
          "num_cand": "U2FsdGVkX19djhxBNhs6tCqZBvHgjjYlypJoz3P18c0=",
          "cpf": "U2FsdGVkX18ZT8OMOUU0bCabBSdbeE5cdzQWuINVIy8="
        }, {
          "num_cand": "U2FsdGVkX1+NSlo6LUQbLOeZuBMJcf3UH8Jz4HyiJsw=",
          "cpf": "U2FsdGVkX1/0BXGaDK2UzSXwWSRdEOKiIGE3PDy3NlA="
        }, {
          "num_cand": "U2FsdGVkX18XslexRPyCdzJF9BZ24UhKTn1sJdx7KBY=",
          "cpf": "U2FsdGVkX1+XPzCdT8D/kUCDvNNS/cAO0kksu0PQtSg="
        }, {
          "num_cand": "U2FsdGVkX18vnc2o5aNEiMTukrHBvtDV5TnK/ru3DFA=",
          "cpf": "U2FsdGVkX19neq1xKKbP3hJGssh+oO9Q1dhoaP949jc="
        }, {
          "num_cand": "U2FsdGVkX1/KG+Wen3omF45UCzlQ1yllJOFJ94yyaEE=",
          "cpf": "U2FsdGVkX19BSUD7mDo0BUYy3LAvH6Ec+zpdJBAU/lQ="
        }, {
          "num_cand": "U2FsdGVkX1/HqMqUjPzdXZrHM47sGNlqj/I2r+el/BY=",
          "cpf": "U2FsdGVkX19mHn6zgPflvdRbPhY86N4d4JGshJmq+3I="
        }, {
          "num_cand": "U2FsdGVkX1+/vXSX0COiQjtjGdyWf2BnothUDHl1/KU=",
          "cpf": "U2FsdGVkX1+FdjkV+MZGMLfD/YYx1/rmDu0jBDCPLXw="
        }, {
          "num_cand": "U2FsdGVkX19iBnf0VTqCtCok4m5fNPI9TZmiWRw1mMg=",
          "cpf": "U2FsdGVkX1+BsdUCILfCKZQ80nDcl1/AwBZrwDimqtI="
        }, {
          "num_cand": "U2FsdGVkX19s1MeJRTx1zHlLMhZWAfaeFtSp0nH7obg=",
          "cpf": "U2FsdGVkX1+yPo/6D8MFNlwqSYH4WmqQSizmAbzhIWs="
        }, {
          "num_cand": "U2FsdGVkX1+WlAcbGJkr3vpOEYxE8CFJjBgsvGQ613A=",
          "cpf": "U2FsdGVkX195/vKCz+WAJcdZFy/d5B2DbOiHf/iqz2w="
        }, {
          "num_cand": "U2FsdGVkX19EV2r/2YU/saPMvRF2gIMmvQOXj6WrSUE=",
          "cpf": "U2FsdGVkX1+XhWX3b5nkyJYognxoLurDHGtLKETAGVI="
        }, {
          "num_cand": "U2FsdGVkX1+gm87POQlOM3v3DdvKlZWYJ3HAJZAVcI4=",
          "cpf": "U2FsdGVkX19j8b4grmdFlxuicX/MDtqB3x1ku8c2m/w="
        }, {
          "num_cand": "U2FsdGVkX188aipBX+YPkegDcYYX2yBfeNih/nBUJX0=",
          "cpf": "U2FsdGVkX1/8V57PG6lGKwmvqIWIBBj6uSOdjZ5z3Bc="
        }, {
          "num_cand": "U2FsdGVkX1/kkhEjQq/X3CW3QQvi3N+BpGk4fXusYMA=",
          "cpf": "U2FsdGVkX19Jeo+4V6F7cx4SCbKGFVFclabUPNdAkWo="
        }, {
          "num_cand": "U2FsdGVkX18gXaEC09bZ11LjHcVn88W50hMppmt2aXg=",
          "cpf": "U2FsdGVkX18wyXRVSvH+Nepll17CLPQ481HX01QJnzM="
        }, {
          "num_cand": "U2FsdGVkX1/BJCPIu6rgQz5gtt2OqIzCOMjATSPorvs=",
          "cpf": "U2FsdGVkX1/aIVm1gUITkSJojMzRnOHJF5qMAY9Yt+E="
        }, {
          "num_cand": "U2FsdGVkX18LaqkDOC+/fmu7dZ/E0w4VczZx5DlrgdU=",
          "cpf": "U2FsdGVkX19xcQHoX11du6LnF1QVamaifv+il3U3HIs="
        }, {
          "num_cand": "U2FsdGVkX18Pxq3GByQUGCi6Bymk7R428HY6J6dU1lw=",
          "cpf": "U2FsdGVkX190Vw6I4kQSzRyX2QhEtGpWl7C3TOWk2XA="
        }, {
          "num_cand": "U2FsdGVkX19gMxkrqCau+qXPi8gYgz2MCh/4jyAw0fs=",
          "cpf": "U2FsdGVkX1+2PDI2ZlIXj+SusGAxnTw44/MAezZKD6k="
        }, {
          "num_cand": "U2FsdGVkX19EWdySO+Ft9zCC4+LfMvDre0E5y8Ggvuc=",
          "cpf": "U2FsdGVkX19TV+SGiRQfIWGDfWkoCqnQFQRoIB6d6D8="
        }, {
          "num_cand": "U2FsdGVkX18FXWtRljLrhBgZbP8QQRswAWROe5cs2tM=",
          "cpf": "U2FsdGVkX19W/jvFaTgdrW2qoCwtj/jjSKE4cJFXccw="
        }, {
          "num_cand": "U2FsdGVkX19BZkn2TEdG/ipyzNKVGiqCFs6GntY+z6k=",
          "cpf": "U2FsdGVkX18eZnxNtTXCc4NXOjbkcO7anx4cCuk7XlY="
        }, {
          "num_cand": "U2FsdGVkX18obCLby2vt7aTp8S1Hxqbt41ynuXVfIfU=",
          "cpf": "U2FsdGVkX1+2z1360rrIlsq1UoC68r7QlZvJU+GeEHM="
        }, {
          "num_cand": "U2FsdGVkX19zUII00U1LkdCPJiDFtSdpJG3l7gKrKhE=",
          "cpf": "U2FsdGVkX1/7otWo9DS531VhcJbvxFlKuZJE3tWOCY8="
        }, {
          "num_cand": "U2FsdGVkX1+RCzLjEWJ7NzmBolkWsTcuHNCmmYqW3Fs=",
          "cpf": "U2FsdGVkX1/avtee+BMr4AhoOj2PcrLUOec+VEmZ7Sk="
        }, {
          "num_cand": "U2FsdGVkX1+TMcc3AtzSLXbVJ63XM9cjeCFdDJ+zK/4=",
          "cpf": "U2FsdGVkX1+6ohueQM0LqlVAr4OwDfUOoYeuEXkFIDo="
        }, {
          "num_cand": "U2FsdGVkX19timqzqOCBj6g8GWwGs7hBYgXNJFM1BRc=",
          "cpf": "U2FsdGVkX18GRaRNn4J7gmvEVm4hYKhUBkl3oZ0CByk="
        }, {
          "num_cand": "U2FsdGVkX1/1b3cGcWmh75BbQJLeHAo86M6cde1ZgjE=",
          "cpf": "U2FsdGVkX1/sw/H0FUF5H7Io2RWsumqe85GhPYIDBmU="
        }, {
          "num_cand": "U2FsdGVkX19WS1LJa0atav8jniY+571jJ1t26M9y5ro=",
          "cpf": "U2FsdGVkX196Y9JkdxKgTSguXkTRpmezFI++hqcRUJ4="
        }, {
          "num_cand": "U2FsdGVkX18ZYPrhaSoxLYphwldZYeKEALIs1qBrk0o=",
          "cpf": "U2FsdGVkX19gqX8HDZqxiVS67UVQJXWD/3YJvxrCuk0="
        }, {
          "num_cand": "U2FsdGVkX1/+lvuiSR9htYVQ+jM6VxBAI6jGBCtGZR4=",
          "cpf": "U2FsdGVkX1+y9vA6OTThXqtAId9bbwQVSfZED1D+K5w="
        }, {
          "num_cand": "U2FsdGVkX1+6o1mzzFyqZxbttXWCgWFO7dtmlj7fQt0=",
          "cpf": "U2FsdGVkX18gY/oYUfYYam451kWT6P293gIywHCMUu0="
        }, {
          "num_cand": "U2FsdGVkX19In8of19GsXGMh5z+B9xWRX/+XY6FIbXU=",
          "cpf": "U2FsdGVkX19DNNd5NL3pk3O/RSNwjrFW+ELhDmJQlmQ="
        }, {
          "num_cand": "U2FsdGVkX18HCp/qe9RuZChUk8HxKo+ACzQ2Dw9DqSA=",
          "cpf": "U2FsdGVkX1+TuhhE10T3chvGoHq1UjFVJtRD34upVpc="
        }, {
          "num_cand": "U2FsdGVkX18tSC5b0qANbsIkTkqMc/mFTuNhgqO9/qM=",
          "cpf": "U2FsdGVkX18mEpH+t38YvLF/kb3TyQoiNxgWADHTWkY="
        }, {
          "num_cand": "U2FsdGVkX18QhzXx4qHfrJT6RNMBY+ucKyJGmKXn+TM=",
          "cpf": "U2FsdGVkX18D+QRnXFMjxS82HLarKOj6dDSWV2/5MKc="
        }, {
          "num_cand": "U2FsdGVkX19G2faqWyxj7Ile/Zd7GhHiwkW0Wvf0PUs=",
          "cpf": "U2FsdGVkX19c0pRYOrEUubIBLYawUNyErhct1uXIbjU="
        }, {
          "num_cand": "U2FsdGVkX18zDrBquGRuSo9R2YG/UKLQ/nZ0/honR6w=",
          "cpf": "U2FsdGVkX19fhW36tutcVy2sbOMwfGwfA31JjVDu/uI="
        }, {
          "num_cand": "U2FsdGVkX1+9VKukcQhIX1JTCAdwJaR5AQp3y+96afk=",
          "cpf": "U2FsdGVkX18AbpH37yway5iD9hfAJy8+t4C4ZqRI0t0="
        }, {
          "num_cand": "U2FsdGVkX1+PFMNrDJmf9nyKf7+TuNoZI5aU1AlDuzw=",
          "cpf": "U2FsdGVkX19D6oElPN4KHJ/WXIR1JHWtgUFRtPyBML8="
        }, {
          "num_cand": "U2FsdGVkX19uEoIorWCfaSNnpGqV07F0G3b+KAcuHLM=",
          "cpf": "U2FsdGVkX18mXSnignZSv3zM03FW69gY3YJ15nckpCI="
        }, {
          "num_cand": "U2FsdGVkX1/n2iuF26FKc7/j26j94Sev5BLPxvjPBOA=",
          "cpf": "U2FsdGVkX1+a1JxXimInsVJYHiuiEaQ8AkXO0lu8DLE="
        }, {
          "num_cand": "U2FsdGVkX19NAZAXnkEAjua4HeSsfOtyiRluSlUOojw=",
          "cpf": "U2FsdGVkX1+xIYOgcEqPO7Kk4YqW6+4WfCxdf+vMRJI="
        }, {
          "num_cand": "U2FsdGVkX1+1X7owSF9ThGt5AQCSs/E3EKUHUvqjm0U=",
          "cpf": "U2FsdGVkX18IRLSElwgMeL5gMCxTPAhUV3finR+xnBU="
        }, {
          "num_cand": "U2FsdGVkX1/wPp4akAkbDE86VibIVMpO3lsxS+Yk2Iw=",
          "cpf": "U2FsdGVkX1/fCh9Vl3fYxhro4M1Gl6rmErXelK8s2a0="
        }, {
          "num_cand": "U2FsdGVkX1/39YgGLhNmNT3VLXz5P/k86ijg5J2vt8A=",
          "cpf": "U2FsdGVkX184LERtiON9akjHL3ZoK3+MIXsyzD+uueM="
        }, {
          "num_cand": "U2FsdGVkX19Y9HTvQZccDwW1+JfAKh19lw4ClisVliA=",
          "cpf": "U2FsdGVkX1/GVFuprKXi+7jRcW/ZneAuhBpo3M0kuVs="
        }, {
          "num_cand": "U2FsdGVkX1+ozRHEpKSK8VTaNhgdImde1Kz7vE/Ek3c=",
          "cpf": "U2FsdGVkX1/mdPOqqITQ8spb7C47r0/6QA84K4DXOAM="
        }, {
          "num_cand": "U2FsdGVkX18uAaQlCbDa9lu3E/BPZttIf6syEzjeVTM=",
          "cpf": "U2FsdGVkX1++jKqGw7yHGxrH9RuI4ut+1tj2mV32Q98="
        }, {
          "num_cand": "U2FsdGVkX19wFky0H+BghM5x4ri/SWtS8WDeipFyNsQ=",
          "cpf": "U2FsdGVkX1/DZXM8RrJVvX9IYJE3Hzklqw49G/zFjBc="
        }, {
          "num_cand": "U2FsdGVkX19BTJI62gO3/JniY9KQiSUDThc5EmFpF1g=",
          "cpf": "U2FsdGVkX1/i/NrdVTEdGKAaSaHZIdZfC2OnDFREwiQ="
        }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2204/rec_titt/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
